import * as Dialog from "@radix-ui/react-dialog";
import { JSX } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Modal = ({ isOpen, onClose, children }: ModalProps): JSX.Element => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="z-100 fixed inset-0 bg-black/50 data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out" />
        <Dialog.Content className="top-1/2 left-1/2 z-100 fixed bg-white shadow-lg p-6 rounded-lg w-[90vw] max-w-[800px] translate-x-[-50%] translate-y-[-50%] data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out">
          <Dialog.Title />
          <Dialog.Description />
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
